module.exports = __webpack_public_path__ + "static/img/5.5ff0141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/5.png
// module id = 7OWr
// module chunks = 0